export function mapFieldsToExcel(items, fields) {
  return items.map(item => Object.fromEntries(
    fields.map(field => {
      const value = typeof field.formatter === 'function' ? field.formatter(item[field.key], field.key, item) : item[field.key]
      return [(field.label || field.key), value]
    })
  ))
}